import GeoDataApiUtils from '../utils/api/geoData';

export const GET_GEODATA_SENT = 'GET_GEODATA_SENT';
export const GET_GEODATA_SUCCEEDED = 'GET_GEODATA_SUCCEEDED';
export const GET_GEODATA_FAILED = 'GET_GEODATA_FAILED';
export const SET_GEODATA = 'SET_GEODATA';

export function getSent() {
  return { type: GET_GEODATA_SENT };
}

export function getSucceeded(data) {
  return {
    type: GET_GEODATA_SUCCEEDED,
    payload: data,
  };
}

export function getFailed(error) {
  return { type: GET_GEODATA_FAILED };
}

export function get() {
  return (dispatch) => {
    dispatch(getSent());
    return GeoDataApiUtils.getGeoData().then(
      (data) => dispatch(getSucceeded(data)),
      (error) => dispatch(getFailed(error)),
    );
  };
}

export function set(geoData) {
  return {
    type: SET_GEODATA,
    payload: geoData,
  };
}
